module.exports = __webpack_public_path__ + "img/sponsors-mobile.a38016e9.png";